'use client';
import React from 'react';

import '@rainbow-me/rainbowkit/styles.css';

import { connectorsForWallets, darkTheme, RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { WagmiProvider, http, createConfig } from 'wagmi';
import { mainnet, shibarium } from '@wagmi/core/chains';
import {
  metaMaskWallet,
  trustWallet,
  walletConnectWallet,
  coinbaseWallet,
  rainbowWallet
} from '@rainbow-me/rainbowkit/wallets';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

type WagmiProviderType = {
  children: React.ReactNode;
};


const projectId = process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID || '';
const appName = 'Shib Metaverse';
const queryClient = new QueryClient();

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [metaMaskWallet, coinbaseWallet, rainbowWallet, walletConnectWallet, trustWallet],
    },
  ],
  {
    appName: appName,
    projectId: projectId,
  }
);

export const config = createConfig({
  chains: [mainnet, shibarium],
  connectors: connectors,
  transports: {
    [mainnet.id]: http(`https://eth-mainnet.g.alchemy.com/v2/${process.env.NEXT_PUBLIC_ALCHEMY_API_KEY}`),
    [shibarium.id]: http(),
  },
  ssr: true,
})
const CustomWagmiProvider = ({ children }: WagmiProviderType) => {
  return (
    <>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider modalSize="compact" theme={darkTheme()}>
            {children}
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </>
  );
};

export default CustomWagmiProvider;